export const getAppStatus = state => state.status;
